import React from 'react';
import { Gift, Check } from 'lucide-react';
import { WaitlistForm } from './WaitlistForm';

export const FinalCta = ({ onJoined }) => (
  <section id="join" className="bg-foreground py-24 text-background md:py-32">
    <div className="mx-auto max-w-3xl px-6 text-center md:px-12">
      <div className="mx-auto mb-6 flex h-14 w-14 items-center justify-center rounded-2xl bg-primary text-primary-foreground">
        <Gift className="h-7 w-7" />
      </div>
      <h2 className="font-display text-3xl font-bold tracking-tight text-background sm:text-4xl lg:text-5xl">
        Be there for the very first reveal
      </h2>
      <p className="mx-auto mt-5 max-w-lg text-base leading-relaxed text-background/70 md:text-lg">
        Giving has always been about the moment, not the money. The first 500 waitlist
        members unlock founding-member perks and priority access. Launching soon.
      </p>
      <div className="mx-auto mt-8 flex justify-center">
        <WaitlistForm idPrefix="final" dark ctaLabel="Secure my spot" withArrow onJoined={onJoined} />
      </div>
      <p className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-1 text-xs text-background/50">
        <span className="flex items-center gap-1.5"><Check className="h-3.5 w-3.5" /> No spam, ever</span>
        <span className="flex items-center gap-1.5"><Check className="h-3.5 w-3.5" /> Unsubscribe anytime</span>
      </p>
    </div>
  </section>
);
